'use client';

import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import AppImage from '@/components/ui/AppImage';

// Backend integration: GET /api/seller/products?stock_lte=10&sort=stock:asc
const lowStockProducts = [
{
  id: 'ls-prod-004',
  name: 'HP Victus 15 Gaming Laptop',
  sku: 'HP-VIC-15-I5',
  stock: 4,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_125a7f7bd-1772574405270.png",
  alt: 'HP gaming laptop with colorful screen',
  soldLast7: 12,
  daysLeft: 2
},
{
  id: 'ls-prod-007',
  name: 'Apple AirPods Pro 2nd Gen',
  sku: 'APL-APP2-WHT',
  stock: 3,
  image: "https://images.unsplash.com/photo-1717855530472-71ab928e85f6",
  alt: 'White Apple AirPods Pro in charging case',
  soldLast7: 8,
  daysLeft: 3
},
{
  id: 'ls-prod-002',
  name: 'Haier 1.5 Ton Inverter AC',
  sku: 'HAI-AC-18T',
  stock: 8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_109ebde21-1777427114403.png",
  alt: 'White wall mounted air conditioner',
  soldLast7: 14,
  daysLeft: 4
},
{
  id: 'ls-prod-012',
  name: 'JBL Charge 5 Portable Speaker',
  sku: 'JBL-CHG5-BLK',
  stock: 6,
  image: "https://images.unsplash.com/photo-1515139491599-60df7520b95e",
  alt: 'Black JBL portable bluetooth speaker on wooden surface',
  soldLast7: 9,
  daysLeft: 5
},
{
  id: 'ls-prod-018',
  name: 'Canon EOS M50 Mark II Camera',
  sku: 'CAN-M50-II-BK',
  stock: 2,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_19ae64626-1769538770468.png",
  alt: 'Black Canon mirrorless camera with lens',
  soldLast7: 4,
  daysLeft: 3
},
{
  id: 'ls-prod-023',
  name: 'Dell 27" 4K USB-C Monitor',
  sku: 'DEL-P2723QE',
  stock: 5,
  image: "https://images.unsplash.com/photo-1719266808503-40b2a06c6908",
  alt: 'Dell 4K monitor showing desktop on white background',
  soldLast7: 7,
  daysLeft: 5
},
{
  id: 'ls-prod-031',
  name: 'Xiaomi Redmi Note 13 Pro',
  sku: 'XMI-RN13P-128',
  stock: 9,
  image: "https://images.unsplash.com/photo-1624434207310-94fc4a4394db",
  alt: 'Xiaomi smartphone front view on white',
  soldLast7: 18,
  daysLeft: 3
}];


export default function LowStockAlerts() {
  if (lowStockProducts?.length === 0) {
    return null;
  }

  return (
    <div className="card p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <AlertTriangle size={16} className="text-warning" />
          <h2 className="text-base font-semibold">Low Stock Alerts</h2>
          <span className="badge-warning">{lowStockProducts?.length} products</span>
        </div>
        <button className="text-xs text-primary font-semibold hover:underline">
          View All Low Stock →
        </button>
      </div>
      <div className="flex gap-3 overflow-x-auto scrollbar-thin pb-2">
        {lowStockProducts?.map((product) =>
        <div
          key={product?.id}
          className={`shrink-0 w-48 p-3 rounded-xl border transition-shadow hover:shadow-card-hover ${
          product?.stock <= 3 ?
          'border-danger/30 bg-danger/5' :
          product?.stock <= 6 ?
          'border-warning/30 bg-warning/5' : 'border-border bg-muted/30'}`
          }>
          
            <div className="flex items-start gap-2 mb-2">
              <AppImage
              src={product?.image}
              alt={product?.alt}
              width={40}
              height={40}
              className="w-10 h-10 rounded-lg object-cover border border-border shrink-0" />
            
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-foreground leading-snug line-clamp-2">
                  {product?.name}
                </p>
              </div>
            </div>

            <div className="space-y-1 mb-3">
              <div className="flex justify-between items-center">
                <span className="text-2xs text-muted-foreground">Stock left</span>
                <span className={`text-xs font-bold tabular-nums ${
              product?.stock <= 3 ? 'text-danger' : product?.stock <= 6 ? 'text-warning' : 'text-foreground'}`
              }>
                  {product?.stock} units
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-2xs text-muted-foreground">Sold (7d)</span>
                <span className="text-xs font-semibold tabular-nums">{product?.soldLast7}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-2xs text-muted-foreground">~Days left</span>
                <span className={`text-xs font-bold ${product?.daysLeft <= 3 ? 'text-danger' : 'text-warning'}`}>
                  {product?.daysLeft}d
                </span>
              </div>
            </div>

            {/* Stock bar */}
            <div className="w-full h-1.5 bg-muted rounded-full mb-3">
              <div
              className={`h-full rounded-full ${
              product?.stock <= 3 ? 'bg-danger' : product?.stock <= 6 ? 'bg-warning' : 'bg-success'}`
              }
              style={{ width: `${Math.min(product?.stock / 20 * 100, 100)}%` }} />
            
            </div>

            <button className="w-full flex items-center justify-center gap-1.5 py-1.5 rounded-lg bg-primary text-white text-xs font-semibold hover:opacity-90 active:scale-95 transition-all duration-150">
              <RefreshCw size={11} />
              Restock
            </button>
          </div>
        )}
      </div>
    </div>);

}